import { Text } from 'pounceV2';
import React from 'react';
import { useTheme } from '@mui/material';
import { getFlowChartColors } from '../../constantsV3';

const MatchCountTagV3 = ({ count, isMin }: { count: number; isMin: boolean }) => {
  const theme = useTheme();
  const FLOW_CHART_COLORS = getFlowChartColors(theme.palette.tokens);
  return (
    <Text variant="body/sm" color={FLOW_CHART_COLORS.SECONDARY_TEXT}>
      {`${isMin ? 'Min' : 'Max'} Match: ${count}`}
    </Text>
  );
};

export default MatchCountTagV3;
